import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, ssrRef, useAsync, useContext, useStore } from "@nuxtjs/composition-api";

import { useAmplitude } from "@/composables";
import { getLtksStore } from "@/store/ltks";
import { handleErrorStatusCode, handleServiceError } from "@/utils/api";
import { withAvatar } from "@/utils/services/LtkItemHeightCalculator";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkDiscoverFeed',
  props: {
  showAvatar: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const amplitude = useAmplitude();
const context = useContext();
const store = useStore();

const paginate = ssrRef(false, "paginate");
const error = ref<unknown | null>(null);
const pending = ssrRef(false, "pending");

const ltkFetchState = computed(() => ({ error: error.value, pending: pending.value }));
const ltks = computed(() => getLtksStore(store).ltkFeed("discover").ids);

const fetch = async () => {
  if (paginate.value || ltks.value.length === 0) {
    try {
      pending.value = true;
      const ltksStore = getLtksStore(store);
      await ltksStore.fetchLtksByFeatured({ overwrite: false });
      pending.value = false;
    } catch (err) {
      error.value = err;
      pending.value = false;
      return handleServiceError({
        context,
        error: {
          status: handleErrorStatusCode(err),
          errorCode: "ltk-feed-not-found",
          developerMessage: `Error fetching discover feed`,
        },
        originalError: err,
      });
    }
  }
  paginate.value = true;
};

const onPaging = () => {
  amplitude?.sendScrollEvent("/scroll/discover", ltks.value.length);
  fetch();
};

useAsync(async () => {
  await fetch();
  return true;
}, "LtkDiscoverFeed fetch");

const itemHeightFunction = computed(() => (props.showAvatar ? withAvatar : undefined));

return { __sfc: true,props, amplitude, context, store, paginate, error, pending, ltkFetchState, ltks, fetch, onPaging, itemHeightFunction }
}

})